<template>
<div class="project_user_assign">
  hey
  {{project_id}}
</div>
</template>
<script>
import Api from "@/api/User"
export default {
  props: [ 'project_id' ],
  data(){
    return {
      errors: []
    }
  },
  mounted(){
    this.retrieve()
  },
  methods: {
    retrieve(){
      let api = new Api()
      api.all({project_id: this.project_id}).then((items) => {
      }).catch((e) => {
        this.errors = e.response.data.errors
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProjectUserAssign.vue?4b0ceced